import { useEffect, useState } from "react";
import { Alert, Button, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import "dayjs/locale/cs";
import { toast } from "react-hot-toast";
import { useFetch } from "../../helpers/useFetch.js";
import { IconAlertCircle } from "@tabler/icons-react";
import { closeModal } from "@mantine/modals";
import { useRevalidator } from "react-router-dom";

export default function PcNoteModal({ context, id, innerProps }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const setShouldFetch = innerProps.setShouldFetch;
  const revalidate = useRevalidator();

  useEffect(() => {
    if (innerProps?.child) {
      form.setValues({ pc_note: innerProps.child.pcNote });
    } else {
      form.reset();
    }
  }, [innerProps]);

  async function handleSubmit(values) {
    setLoading(true);

    const child = innerProps?.child;

    const res = await useFetch(`/children/${child.id}/pc-note`, "PUT", { ...values });

    if (res.status === "ok") {
      context.closeModal(id);
      form.reset();
      if (setShouldFetch) setShouldFetch(true);
      setLoading(false);
      toast.success("Počítačová poznámka upravena.");
      revalidate.revalidate();
    } else {
      setLoading(false);
      setError(res.message);
    }
  }

  const form = useForm({
    initialValues: {
      pc_note: "",
    },
  });
  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      {error && (
        <Alert
          icon={<IconAlertCircle size={16} stroke={1.5} />}
          title="Při úpravě počítačové poznámky dítěte nastala chyba."
          color="red"
          mb="md"
          mt="lg"
          withCloseButton
          closeButtonLabel="Zavřít upozornění"
          onClose={() => setError(false)}>
          {error}
        </Alert>
      )}
      <Textarea
        minRows={2}
        maxRows={10}
        autosize
        label="Poznámka"
        placeholder="Pepův mail na Fornite: pepyk@email.cz"
        mb="sm"
        {...form.getInputProps("pc_note")}
      />

      <Button fullWidth type="submit" loading={loading} mt="sm">
        Upravit počítačovou poznámku
      </Button>
    </form>
    // </Modal>
  );
}
